"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _action = require("../../spinner-overlay/action");

var _commonConstants = require("../../../utils/common-constants");

var _policyAdminService = require("../../../services/policy-admin-service");

var _lodash = require("lodash");

var _actions = require("./actions");

var _constants = require("./constants");

var _service = require("../../policy/Members/service");

var _actions2 = require("../../policy/Members/actions");

var _commonUtils = require("../../../utils/common-utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(LoadPolicyDataWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(LoadPolicyDataWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(LoadPolicyJSONDataWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(LoadPolicyJSONDataWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(addPolicyWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(addPolicyWorker);

function LoadPolicyDataWatcher() {
  return regeneratorRuntime.wrap(function LoadPolicyDataWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.LoadPolicyDataType.CLONE_LOAD_POLICY_REQUEST, LoadPolicyDataWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function LoadPolicyDataWorker(action) {
  var _action$payload, id, history, consumer, consumerEntityId, redirectPath, ClonePolicyData, usersToFetch, tagsToFetch, tagsData, userData, _response$data, response, reason;

  return regeneratorRuntime.wrap(function LoadPolicyDataWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, id = _action$payload.id, history = _action$payload.history, consumer = _action$payload.consumer, consumerEntityId = _action$payload.consumerEntityId, redirectPath = _action$payload.redirectPath;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.put)({
            type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_LOADING
          });

        case 4:
          _context2.next = 6;
          return (0, _effects.call)(_policyAdminService.getPolicyByEntity, id, null, consumer, consumerEntityId);

        case 6:
          ClonePolicyData = _context2.sent;
          usersToFetch = (0, _commonUtils.getPolicyUsersMapById)(ClonePolicyData);
          tagsToFetch = (0, _commonUtils.getPolicyUserTagsMapById)(ClonePolicyData);

          if ((0, _lodash.isEmpty)(tagsToFetch)) {
            _context2.next = 15;
            break;
          }

          _context2.next = 12;
          return (0, _effects.put)((0, _actions2.getGroupsRequestLoading)());

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(_service.getSelectedUserTagsData, tagsToFetch);

        case 14:
          tagsData = _context2.sent;

        case 15:
          if ((0, _lodash.isEmpty)(usersToFetch)) {
            _context2.next = 21;
            break;
          }

          _context2.next = 18;
          return (0, _effects.put)((0, _actions2.getUsersRequestLoading)());

        case 18:
          _context2.next = 20;
          return (0, _effects.call)(_service.getSelectedUsersData, usersToFetch);

        case 20:
          userData = _context2.sent;

        case 21:
          ClonePolicyData.isConditionTypeJSON = _typeof(ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) === 'object';

          if (!(0, _lodash.isEmpty)(ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) && typeof (ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) === 'string') {
            ClonePolicyData['condition'] = JSON.parse(ClonePolicyData.condition);
          }

          _context2.next = 25;
          return (0, _effects.put)({
            type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_SUCCESS,
            payload: ClonePolicyData
          });

        case 25:
          _context2.next = 27;
          return (0, _effects.put)((0, _actions2.getGroupsRequestSuccess)((0, _lodash.isEmpty)(tagsData) ? [] : tagsData));

        case 27:
          _context2.next = 29;
          return (0, _effects.put)((0, _actions2.getUsersRequestSuccess)((0, _lodash.isEmpty)(userData) ? [] : userData));

        case 29:
          _context2.next = 38;
          break;

        case 31:
          _context2.prev = 31;
          _context2.t0 = _context2["catch"](1);
          response = _context2.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 37;
          return (0, _effects.put)({
            type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_FAILURE,
            payload: {
              error: reason
            }
          });

        case 37:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.errorGetPolicyData(reason),
              type: _commonConstants.errorNotificationType,
              time: 'normal'
            }
          });

        case 38:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 31]]);
}

function LoadPolicyJSONDataWatcher() {
  return regeneratorRuntime.wrap(function LoadPolicyJSONDataWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_REQUEST, LoadPolicyJSONDataWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function LoadPolicyJSONDataWorker(action) {
  var _action$payload2, name, history, consumer, consumerEntityId, redirectPath, ClonePolicyData, _response$data2, response, reason;

  return regeneratorRuntime.wrap(function LoadPolicyJSONDataWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload2 = action.payload, name = _action$payload2.name, history = _action$payload2.history, consumer = _action$payload2.consumer, consumerEntityId = _action$payload2.consumerEntityId, redirectPath = _action$payload2.redirectPath;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.put)((0, _actions.getPolicyByNameLoading)());

        case 4:
          _context4.next = 6;
          return (0, _effects.call)(_policyAdminService.getPolicyByEntity, name, null, consumer, consumerEntityId);

        case 6:
          ClonePolicyData = _context4.sent;
          ClonePolicyData.isConditionTypeJSON = _typeof(ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) === 'object';

          if (!(0, _lodash.isEmpty)(ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) && typeof (ClonePolicyData === null || ClonePolicyData === void 0 ? void 0 : ClonePolicyData.condition) === 'string') {
            ClonePolicyData['condition'] = JSON.parse(ClonePolicyData.condition);
          }

          _context4.next = 11;
          return (0, _effects.put)((0, _actions.getPolicyByNameSuccess)(ClonePolicyData));

        case 11:
          _context4.next = 20;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](1);
          response = _context4.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message) || '';
          _context4.next = 19;
          return (0, _effects.put)((0, _actions.getPolicyByNameFailure)(reason));

        case 19:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.errorGetPolicyData(reason),
              type: _commonConstants.errorNotificationType,
              time: 'normal'
            }
          });

        case 20:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 13]]);
}

function addPolicyWatcher() {
  return regeneratorRuntime.wrap(function addPolicyWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.ClonePolicyType.CLONE_POLICY_REQUEST, addPolicyWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function addPolicyWorker(action) {
  var _action$payload3, history, data, consumer, consumerEntityId, redirectPath, response, _response;

  return regeneratorRuntime.wrap(function addPolicyWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload3 = action.payload, history = _action$payload3.history, data = _action$payload3.data, consumer = _action$payload3.consumer, consumerEntityId = _action$payload3.consumerEntityId, redirectPath = _action$payload3.redirectPath;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.put)((0, _actions.createPolicyLoading)());

        case 4:
          _context6.next = 6;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: _constants.translatedStrings.addingPolicy
          }));

        case 6:
          _context6.next = 8;
          return (0, _effects.call)(_policyAdminService.createPolicy, {
            data: data,
            consumer: consumer,
            consumerEntityId: consumerEntityId
          });

        case 8:
          response = _context6.sent;
          _context6.next = 11;
          return (0, _effects.put)((0, _actions.createPolicySuccess)(response));

        case 11:
          _context6.next = 13;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 13:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.policyCreatedSuccessMessage,
              type: _commonConstants.successNotificationType,
              time: 'normal'
            }
          });
          _context6.next = 23;
          break;

        case 16:
          _context6.prev = 16;
          _context6.t0 = _context6["catch"](1);
          _response = _context6.t0.response;
          _context6.next = 21;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 21:
          _context6.next = 23;
          return (0, _effects.put)((0, _actions.createPolicyFailure)(_response));

        case 23:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 16]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(addPolicyWatcher), (0, _effects.fork)(LoadPolicyDataWatcher), (0, _effects.fork)(LoadPolicyJSONDataWatcher)]);

exports.default = _default;